import { render, staticRenderFns } from "./TcAppointmentForm.vue?vue&type=template&id=56adb894&"
import script from "./TcAppointmentForm.vue?vue&type=script&lang=js&"
export * from "./TcAppointmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56adb894')) {
      api.createRecord('56adb894', component.options)
    } else {
      api.reload('56adb894', component.options)
    }
    module.hot.accept("./TcAppointmentForm.vue?vue&type=template&id=56adb894&", function () {
      api.rerender('56adb894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcAppointmentForm.vue"
export default component.exports